import { SecurityGroups } from "../../core/common/Constants";
import Model from "../../core/model/Model";
import ValidatableObject from "../../core/model/validation/ValidatableObject";

export interface TUser {
  id: number;
  username: string;
  languageCode: string;
  roles: string[];
  code: string;
  organisationId: number;
  visibilityLevel: number;
}

export interface IUser extends TUser {
  isMemberOf(
    roleName: string | string[] | undefined,
    strict?: boolean
  ): boolean;
  isAdmin(): boolean;
  isSuperAdmin(): boolean;
  isOperator(): boolean;
  isUser(): boolean;
  canEdit(organisationId: number): boolean;
}

const User = Model((model: TUser): IUser => {
  const _user: TUser = Object.assign({}, model);

  let create = (value: IUser): IUser => {
    let obj = ValidatableObject(value);
    return obj;
  };
  const isMemberOf = (
    roleName: string | string[] | undefined,
    strict: boolean = false
  ) => {
    if (!roleName) {
      return !strict;
    }
    if (typeof roleName === "string") {
      return (_user.roles || []).indexOf(roleName) !== -1;
    } else {
      return (_user.roles || []).some(
        (group) => roleName.indexOf(group) !== -1
      );
    }
  };

  let user = {
    get id() {
      return _user.id;
    },
    get username() {
      return _user.username;
    },
    get languageCode() {
      return _user.languageCode;
    },
    get roles() {
      return _user.roles;
    },
    get code() {
      return _user.code;
    },
    get organisationId() {
      return _user.organisationId;
    },
    get visibilityLevel() {
      return _user.visibilityLevel;
    },

    isMemberOf,
    isAdmin() {
      return (
        isMemberOf(SecurityGroups.ADMIN, true) ||
        isMemberOf(SecurityGroups.SUPER_ADMIN, true)
      );
    },

    isSuperAdmin() {
      return isMemberOf(SecurityGroups.SUPER_ADMIN, true);
    },
    isOperator() {
      return (
        isMemberOf(SecurityGroups.OPERATER, true) &&
        this.organisationId !== null
      );
    },
    isUser() {
      const vars =
        !this.isAdmin() && !this.isOperator() && !this.isSuperAdmin();
      return vars || isMemberOf(SecurityGroups.USER, true);
    },
    canEdit(organisationId: number) {
      if (this.isSuperAdmin() || _user.organisationId === organisationId) {
        return true;
      }
      return false;
    }
  };

  return create(user);
});

export default User;
